module.exports = __webpack_public_path__ + "Search.svg";